var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.887 12.146a.75.75 0 0 1-.104-1.493 2.133 2.133 0 0 0 1.827-2.1 2.115 2.115 0 0 0-1.779-2.094.75.75 0 0 1 .245-1.48 3.611 3.611 0 0 1 3.034 3.576 3.642 3.642 0 0 1-3.12 3.584.737.737 0 0 1-.103.007",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "community_svg__a",
    width: 5,
    height: 5,
    x: 18,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.978 14.002h3.794v4.53h-3.794v-4.53Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#community_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.861 18.532a.75.75 0 0 1-.267-1.451c.678-.258.678-.543.678-.68 0-.438-.557-.745-1.655-.909a.752.752 0 0 1-.63-.854.755.755 0 0 1 .853-.63c2.423.364 2.932 1.502 2.932 2.393 0 .544-.214 1.537-1.644 2.082a.759.759 0 0 1-.267.049",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.887 15.914c-2.376 0-5.21.292-5.21 1.682 0 1.401 2.834 1.695 5.21 1.695s5.208-.29 5.208-1.678c0-1.404-2.832-1.699-5.208-1.699m0 4.877c-1.66 0-6.71 0-6.71-3.195 0-3.182 5.05-3.182 6.71-3.182 1.659 0 6.708 0 6.708 3.2 0 3.177-4.873 3.177-6.708 3.177M11.886 5.5a3.072 3.072 0 0 0-3.068 3.069c-.003.82.311 1.587.886 2.166s1.341.9 2.157.903l.025.75v-.75a3.072 3.072 0 0 0 3.07-3.069 3.073 3.073 0 0 0-3.07-3.069m0 7.638h-.027a4.52 4.52 0 0 1-3.219-1.346 4.518 4.518 0 0 1-1.322-3.226A4.573 4.573 0 0 1 11.886 4c2.52 0 4.57 2.05 4.57 4.569a4.574 4.574 0 0 1-4.57 4.569M5.886 12.146a.737.737 0 0 1-.104-.007 3.641 3.641 0 0 1-3.12-3.582A3.612 3.612 0 0 1 5.699 4.98a.75.75 0 0 1 .244 1.48 2.116 2.116 0 0 0-1.78 2.096 2.132 2.132 0 0 0 1.827 2.098.75.75 0 0 1-.103 1.493M2.912 18.531a.759.759 0 0 1-.267-.049C1.214 17.936 1 16.943 1 16.4c0-.89.509-2.029 2.933-2.392a.755.755 0 0 1 .853.63.752.752 0 0 1-.631.854c-1.098.164-1.655.47-1.655.908 0 .137 0 .421.679.68a.75.75 0 0 1-.267 1.451",
    clipRule: "evenodd"
  })));
};
export default SvgCommunity;